import type { AttributeInput } from '@ifixit/shopify-storefront-client';
import Cookies from 'js-cookie';
import type { QueryCart } from '../models/cart';

const FACEBOOK_ATTRIBUTE_KEY = 'facebook_click';

interface SyncAttributesResult {
   attributes: AttributeInput[];
   needsSync: boolean;
}

export function getSyncedAttributes(cart: QueryCart | null): SyncAttributesResult {
   if (cart == null) {
      return { attributes: [], needsSync: false };
   }

   const localAttributes = new Map([[FACEBOOK_ATTRIBUTE_KEY, facebookClickCookieValue()]]);
   const cartAttributes = new Map(cart.attributes.map(({ key, value }) => [key, value]));
   const allKeys = new Set([...cartAttributes.keys(), ...localAttributes.keys()]);

   let needsSync = false;
   const syncedAttributes: AttributeInput[] = [];

   for (const key of allKeys) {
      const currentValue = cartAttributes.get(key);

      if (localAttributes.has(key)) {
         const localValue = localAttributes.get(key);
         needsSync ||= localValue !== currentValue;
         if (localValue != null) {
            syncedAttributes.push({ key, value: localValue });
         }
      } else if (currentValue) {
         syncedAttributes.push({ key, value: currentValue });
      }
   }

   return { attributes: syncedAttributes, needsSync };
}

/**
 * https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc
 */
function facebookClickCookieValue() {
   return Cookies.get('_fbc');
}
